import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import infoList from "@/mixins/infoList";
import exportCsv from "@/mixins/exportCsv";
import { payLog } from "@/api/data";
export default {
  name: "compPay",
  mixins: [infoList, exportCsv],
  props: {
    serverList: Object
  },
  data: function data() {
    return {
      listApi: payLog
    };
  },
  methods: {
    goMethod: function goMethod(e, m) {
      if (e == "1") {
        this.loadTatleData(m);
      } else {
        this.exportText(m);
      }
    },
    loadTatleData: function loadTatleData(m) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // this.$router.push({ query: {} });
              _this.searchInfo = m;
              _this.loading = true;
              _context.next = 4;
              return _this.getTableData(1);
            case 4:
              _this.loading = false;
              if (!_this.tableData || _this.tableData && _this.tableData.length === 0) {
                _this.$message({
                  message: "充值日志，暂无数据"
                });
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    exportText: function exportText(m) {
      var url = "/api/xcpGameLog/exportPayLog?";
      this.exportCsv(url, m);
    },
    // 获取到这一行的roleID然后跳转到玩家信息
    goRouterMsg: function goRouterMsg(e) {
      window.localStorage.setItem("roleId", e);
      this.$router.push({
        name: "userRoleInfo",
        query: {
          roleId: e
        }
      });
    }
  }
};